import React from 'react'
import { connect } from 'react-redux'
import {
  fetchStationUpdatesIfNeeded
} from '~/features/actions'

class StationUpdates extends React.Component {
  componentDidMount(){
    const { match, history, dispatch } = this.props
    dispatch(fetchStationUpdatesIfNeeded())
  }

  render() {
    const {stationUpdates} = this.props
    function getId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);
        if (match && match[2].length == 11) {
            return match[2];
        } else {
            return 'error';
        }
    }
    const updates = stationUpdates.items.map( (item, index) =>
    {
      var vidId, vidURL
      if (item.embed_video.length > 0) {
        vidId = getId(item.embed_video[0].value)
        vidURL = "https://www.youtube.com/embed/" + vidId
      }

      return (
        <div className='more-weird' key={index}>
          <h3>{item.title[0].value}</h3>
          { vidURL && <iframe width="560" height="315" src={vidURL} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe> }
          {item.field_image.length > 0 && <img src={item.field_image[0].url} /> }
          <div dangerouslySetInnerHTML={{ __html: item.body[0].value }}></div>
          <div className="clear" />
        </div>
      )
    })

    if (stationUpdates.items.length > 0) {
			return (
	      <div className="off-air-updates">
	        <div className="margin">
	          <h2>Off-Air</h2>
	          {updates}
	        </div>
	      </div>
    	)
		}
		else {
			return null;
		}
  }

}

export default connect(state => ({stationUpdates: state.stationUpdates})) (StationUpdates)
